import { combineReducers } from 'redux-immutable'
import projectInformationListReducer from './project-information-list-reducer'
import projectInformationGetReducer from './project-information-get-reducer'
import projectInformationCreateReducer from './project-information-create-reducer'
import projectInformationEditReducer from './project-information-edit-reducer'
import projectInformationAutoAddReducer from './project-information-auto-add-reducer'
import projectInformationAutoFillReducer from './project-information-auto-fill-reducer'
import projectInformationChangeStatusReducer from './project-information-change-project-status-reducer'
import projectInformationSubmitReducer from './project-information-submit-reducer'
import projectInformationApproverReducer from './project-information-approve-reducer'
import projectInformationManualReducer from './project-information-manual'
import projectInformationExportReducer from './project-information-export-reducer'
import projectInformationSaveSnapshotReducer from './project-information-save-snapshot-reducer'
import projectInformationGetSnapshotReducer from './project-information-get-snapshot-reducer'
import projectInformationCheckSubmitReducer from './project-information-check-submit-reducer'
import projectInformationReducer from './project-information-reducer'
import revenuePlanningReducer from './revenue-planning-reducer'

export default combineReducers({
  projectInformationList: projectInformationListReducer,
  projectInformationGet: projectInformationGetReducer,
  projectInformationCreate: projectInformationCreateReducer,
  projectInformationEdit: projectInformationEditReducer,
  projectInformationAutoAdd: projectInformationAutoAddReducer,
  projectInformationAutoFill: projectInformationAutoFillReducer,
  projectInformationChangeStatus: projectInformationChangeStatusReducer,
  projectInformationCheckSubmit: projectInformationCheckSubmitReducer,
  projectInformationSubmit: projectInformationSubmitReducer,
  projectInformationApprove: projectInformationApproverReducer,
  projectInformationManual: projectInformationManualReducer,
  projectInformationExport: projectInformationExportReducer,
  projectInformationSaveSnapshot: projectInformationSaveSnapshotReducer,
  projectInformationGetSnapshot: projectInformationGetSnapshotReducer,
  projectInformation: projectInformationReducer,
  revenuePlanning: revenuePlanningReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/project-information/index.js